/**
 * BiometricService — Face ID / Touch ID / Fingerprint login.
 * Uses window.Capacitor.Plugins to avoid build-time imports.
 * No-op on web.
 */
import { isNative } from '../utils/platform';

function getBiometricPlugin() {
  return window.Capacitor?.Plugins?.BiometricAuth || null;
}

function getPreferencesPlugin() {
  return window.Capacitor?.Plugins?.Preferences || null;
}

const STORAGE_KEY = 'duofit_biometric_token';

export class BiometricService {
  static async isAvailable() {
    const bio = getBiometricPlugin();
    if (!bio) return false;
    try {
      const info = await bio.checkBiometry();
      return info.isAvailable;
    } catch { return false; }
  }

  static async getBiometryLabel() {
    const bio = getBiometricPlugin();
    if (!bio) return 'Biometria';
    try {
      const info = await bio.checkBiometry();
      if (!info.isAvailable) return 'Biometria';
      if (info.biometryType === 1) return 'Face ID';    // BiometryType.faceId
      if (info.biometryType === 2) return 'Touch ID';   // BiometryType.touchId
      return 'Odcisk palca';
    } catch { return 'Biometria'; }
  }

  static async enrollToken(jwt) {
    const prefs = getPreferencesPlugin();
    if (!prefs) return;
    await prefs.set({ key: STORAGE_KEY, value: jwt });
  }

  static async clearEnrolledToken() {
    const prefs = getPreferencesPlugin();
    if (!prefs) return;
    await prefs.remove({ key: STORAGE_KEY });
  }

  static async hasEnrolledToken() {
    const prefs = getPreferencesPlugin();
    if (!prefs) return false;
    const { value } = await prefs.get({ key: STORAGE_KEY });
    return !!value;
  }

  static async authenticate() {
    if (!isNative) return null;
    const bio = getBiometricPlugin();
    if (!bio) return null;
    const available = await this.isAvailable();
    if (!available) return null;
    const hasToken = await this.hasEnrolledToken();
    if (!hasToken) return null;

    try {
      await bio.authenticate({
        reason: 'Zaloguj się do DuoFit',
        cancelTitle: 'Użyj hasła',
        allowDeviceCredential: false,
      });
      const prefs = getPreferencesPlugin();
      const { value } = await prefs.get({ key: STORAGE_KEY });
      return value;
    } catch {
      return null;
    }
  }
}
